const asPositiveTeamId = (value) => {
  const teamId = Number(value);
  return Number.isInteger(teamId) && teamId > 0 ? teamId : null;
};

const normalizeUserTeamsForEdit = (loadedTeams = [], permittedTeamIds = []) => {
  const teams = Array.isArray(loadedTeams) ? loadedTeams : [];
  const seen = new Set();

  return teams.reduce((accumulator, teamEntry) => {
    const rawTeam = teamEntry?.team ?? teamEntry;
    const teamId = asPositiveTeamId(rawTeam?.id ?? teamEntry?.id ?? teamEntry?.teamId ?? rawTeam?.teamId);

    if (!teamId || seen.has(teamId)) {
      return accumulator;
    }

    const safeRoles = Array.isArray(teamEntry?.roles) ? teamEntry.roles : [];
    const teamRoles = safeRoles.filter((role) => role !== null && role !== undefined && role !== "");
    const teamName = rawTeam?.name ?? teamEntry?.name ?? "";

    const shouldKeep = permittedTeamIds.length === 0 || permittedTeamIds.includes(teamId) || teamEntry?.teamId === teamId || rawTeam?.id === teamId;

    seen.add(teamId);
    if (!shouldKeep) {
      accumulator.push({ teamId, name: teamName, roles: teamRoles });
      return accumulator;
    }

    accumulator.push({ teamId, name: teamName, roles: teamRoles });
    return accumulator;
  }, []);
};

module.exports = {
  normalizeUserTeamsForEdit,
};
